export default function convertUnitToMap({ isImperial, value }) {
  return value * (isImperial ? 0.3048 : 1)
}



// WEBPACK FOOTER //
// ./src/helpers/convertUnitToMap.js